import { createSlice } from "@reduxjs/toolkit";
import { initialUplinkFieldsState } from "../hooks/useUplinkArgs";
export const speedMenuFieldsState = {
    uplinkFields: initialUplinkFieldsState,
    sign: "",
    mach: false,
    showInvalid: false,
    scratchpad: false,
};
export const headingMenuFieldsState = {
    uplinkFields: initialUplinkFieldsState,
    direction: null,
    showInvalid: false,
    scratchpad: false,
};
export const altitudeMenuFieldsState = {
    uplinkFields: initialUplinkFieldsState,
    trialPlan: false,
    altModifier: null,
    showInvalid: false,
};
export const xResMenuFieldsState = {
    uplinkFields: initialUplinkFieldsState,
    speedSign: "",
    mach: false,
    selectedFix: null,
    selectedAlt: null,
    selectedSpeed: null,
    fixInputIsValid: null,
    altInputIsValid: null,
    speedInputIsValid: null,
};
export const routeMenuFieldsState = {
    append: null,
    uplinkFields: initialUplinkFieldsState,
    includePar: false,
    frc: false,
    showAllAPRs: true,
    amend: true,
};
export const holdMenuFieldsState = {
    uplinkFields: initialUplinkFieldsState,
    selectedFixName: null,
    legLength: null,
    direction: "N",
    turns: "RT",
    efc: 0,
    outboundRadial: 0,
};
export const initialAltimSetTemplateFields = {
    open: false,
    selectedStation: null,
    draftState: [],
    peaStations: [],
};
const initialState = {
    ROUTE_MENU: routeMenuFieldsState,
    ALTITUDE_MENU: altitudeMenuFieldsState,
    SPEED_MENU: speedMenuFieldsState,
    HEADING_MENU: headingMenuFieldsState,
    X_RES_MENU: xResMenuFieldsState,
    HOLD_MENU: holdMenuFieldsState,
    FREETEXT_MENU: null,
    ALTIM_SET_TEMPLATE_MENU: initialAltimSetTemplateFields,
    PREV_ROUTE_MENU: null,
};
export const viewMenuFieldsSlice = createSlice({
    name: "viewMenuFields",
    initialState,
    reducers: {
        setViewMenuFields(state, action) {
            Object.assign(state[action.payload.menu] ?? {}, action.payload.fields);
        },
        resetViewMenuFields(state, action) {
            state[action.payload] = initialState[action.payload];
        },
    },
});
export const viewMenuFieldsReducer = viewMenuFieldsSlice.reducer;
export const { setViewMenuFields, resetViewMenuFields } = viewMenuFieldsSlice.actions;
export const viewMenuFieldsSelector = (state, menu) => state.viewMenuFields[menu];
export function updateViewMenuFields(view, field, d) {
    return (dispatch, getState) => {
        const state = getState();
        const fields = viewMenuFieldsSelector(state, view);
        if (fields) {
            // @ts-ignore
            const newValue = typeof d === "function" ? d(fields[field]) : d;
            dispatch(setViewMenuFields({ menu: view, fields: { ...fields, [field]: newValue } }));
        }
    };
}
//# sourceMappingURL=viewMenuFieldsSlice.js.map